import React from 'react';
import { useParams } from 'react-router-dom';

import LogSyncDetailsContainer from '@totem/components/administration/logSync/details/LogSyncDetailsContainer';
import LogSyncDetailsLayout, {
  LogSyncDetailsExtra,
} from '@totem/components/administration/logSync/details/LogSyncDetailsLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const LogSyncDetailsPage = () => {
  const { id } = useParams();

  return (
    <LogSyncDetailsContainer logSyncId={id}>
      <ContentLayout>
        <IBCard
          isCovered
          title="Log Sync Result"
          extra={<LogSyncDetailsExtra />}
        >
          <LogSyncDetailsLayout />
        </IBCard>
      </ContentLayout>
    </LogSyncDetailsContainer>
  );
};

export default LogSyncDetailsPage;
